import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

const ConfirmDialog = ({
  open,
  title,
  message,
  detail,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  confirmColor = 'error',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">
        {title || 'Confirmar'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {message}
        </DialogContentText>
        {detail}
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={onCancel} color="inherit">
          {cancelText || 'Cancelar'}
        </Button>
        <Button type="button" onClick={onConfirm} color={confirmColor} variant="contained" autoFocus>
          {confirmText || 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
